import { ReactNode } from 'react';
import InlineSVG from 'react-inlinesvg';
import connectError from '@client/assets/icons/connect-error.svg';
import { ty } from '@client/styles/typography';

export type Props = {
  children: ReactNode;
};

export const ErrorScreen = ({ children }: Props): JSX.Element => (
  // The design system ships no `gap-5`, so the 20px the design calls for is
  // set inline rather than as a utility class.
  <div className="flex flex-col items-center" style={{ gap: '20px' }}>
    <InlineSVG src={connectError} />
    <p className={`${ty('paragraph400')} text-center`}>{children}</p>
  </div>
);
